import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { useSelector } from "../hooks/react-redux";

const Loader = (): React.ReactElement => {
  const isLoading = useSelector((state) => state.global.isLoading > 0);

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loader;
